import { FC, useState } from 'react';

import classNames from 'classnames';

import Button from '../common/button';
import { useAppSelector } from '../../hooks/redux';
import { EmoView } from '../tools/detector-emo/emo-view';

export const Reactions: FC<{
  sendEmotionsSelect?: (result: { category: string[]; emo: string[] }) => void;
}> = ({ sendEmotionsSelect }) => {
  const psyTools = useAppSelector((state) => state.psyToolsSlice.tools);
  const [reactionId, setReactionId] = useState<string[]>([]);
  const [selectedEmo, setSelectedEmo] = useState<string[]>([]);
  const [selectionFinished, setSelectionFinished] = useState(false);

  const settings = psyTools.find((el) => el.name === 'emotions_detection')?.psy_tool_settings;
  const handleSelect = () => {
    if (!reactionId) return;

    const payload = {
      category: reactionId,
      emo: selectedEmo,
    };

    sendEmotionsSelect?.(payload);
    setSelectionFinished(true);
  };

  if (selectionFinished) {
    return (
      <div className="w-full h-full pr-[0.25rem] ">
        <div
          className={classNames(
            'w-full h-full bg-grey1 md:rounded-[20px] p-3.5 md:p-4 relative flex flex-col justify-between ',
            {
              '!pr-[11px]': reactionId,
            },
          )}
        >
          <div className="w-full flex md:flex-col flex-wrap overflow-y-auto white-scroll gap-[15px] md:items-center">
            {selectedEmo.map((el, idx) => (
              <div
                className="w-full max-w-[240px] 2xl:max-w-[360px] bg-blackBaseOpacity20 rounded-[5px] py-[2px] px-0 lg:p-[5px_10px] text-center text-[16px] text-white font-semibold mx-auto"
                key={idx}
              >
                {el}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  const onEmotionClick = (item: string, selected: string[]) => {
    if (selected.includes(item)) {
      setSelectedEmo([...selected.filter((el) => el !== item)]);
    } else {
      setSelectedEmo([...selected, item]);
    }
  };

  return (
    <div className="w-full h-full pr-[0.25rem]">
      <div className="w-full h-full flex flex-col rounded-[5px] md:rounded-[15px] bg-[#63656A] justify-between">
        <div className="w-full h-full max-h-full scroll-white overflow-y-auto p-[2rem]">
          <EmoView
            settings={settings}
            selectedEmo={selectedEmo}
            onEmotionClick={onEmotionClick}
            reactionId={reactionId}
            setReactionId={setReactionId}
          />
        </div>

        <div className="mt-auto w-full max-w-[222px] xl:mb-4 flex justify-center mx-auto  p-[0.3rem]">
          <Button
            type="primary"
            className="!text-base xl:!text-base !self-center"
            disabled={selectedEmo.length === 0}
            onClick={() => handleSelect()}
          >
            Выбрать
          </Button>
        </div>
      </div>
    </div>
  );
};
